import { CircleCheck, CircleDashed, MonitorUp, OctagonX } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import type { StatusBuild } from '@/data/types';
import { usePodeVer } from '@/hooks/use-acesso';
import { ROTULO_STATUS } from '@/lib/capabilities';

/**
 * Hard rule 2 — estado nunca é só cor.
 *
 * Cada status devolve cor semântica + ícone + rótulo textual: o daltônico lê o
 * glifo e o texto mesmo sem distinguir o matiz. As cores vêm do theme
 * (`success`/`danger`/neutro), nunca de hex.
 */

const ICONE_STATUS: Record<StatusBuild, typeof CircleCheck> = {
  nao_homologado: CircleDashed,
  homologado: CircleCheck,
  reprovado: OctagonX,
};

const TOM_STATUS: Record<StatusBuild, 'neutral' | 'success' | 'warning' | 'danger'> = {
  nao_homologado: 'neutral',
  homologado: 'success',
  reprovado: 'danger',
};

export function StatusIcone({ status }: { status: StatusBuild }) {
  const Icone = ICONE_STATUS[status];
  return <Icone aria-hidden="true" />;
}

export function StatusBuildBadge({ status, className }: { status: StatusBuild; className?: string }) {
  return (
    <Badge tone={TOM_STATUS[status]} icon={<StatusIcone status={status} />} className={className}>
      {ROTULO_STATUS[status]}
    </Badge>
  );
}

/** Selo da versão que está no painel do cliente — azul cheio, o único "filled" do feed. */
export function NoPainelBadge({ className }: { className?: string }) {
  const ver = usePodeVer('painel');
  if (!ver) return null;
  return (
    <Badge tone="primary" filled icon={<MonitorUp aria-hidden="true" />} className={className}>
      No painel
    </Badge>
  );
}
